<template>
  <div class="mobile-app-stores__app-links">
    <a
      v-if="googlePlayLink"
      :href="googlePlayLink"
      class="store-links store-links-google"
      target="_blank"
      rel="noopener"
      aria-label="Google Play"
      @click="onGooglePlayClick"
    >
      <img
        class="icon"
        src="../../assets/google-play.svg"
        alt=""
        loading="lazy"
        width="85"
        height="26"
      >
    </a>
    <a
      v-if="appStoreLink"
      :href="appStoreLink"
      class="store-links store-links-apple"
      target="_blank"
      rel="noopener"
      aria-label="Apple Store"
      @click="onAppStoreClick"
    >
      <img
        class="icon"
        src="../../assets/app-store.svg"
        width="85"
        height="26"
        alt=""
        loading="lazy"
      >
    </a>
    <a
      v-if="huaweiLink"
      :href="huaweiLink"
      class="store-links store-links-huawei"
      target="_blank"
      rel="noopener"
      aria-label="Huawei Store"
      @click="onHuaweiStoreClick"
    >
      <img
        class="icon icon-desktop"
        src="../../assets/app-gallery.png"
        alt=""
        loading="lazy"
        width="85"
        height="26"
      >
      <img
        class="icon icon-mobile"
        src="../../assets/huawei-app-mobile.png"
        width="35"
        height="35"
        alt=""
        loading="lazy"
      >
    </a>
  </div>
</template>

<script>
export default {
  name: 'MobileStoresShopLinks',
  props: {
    googlePlayLink: {
      type: String,
      required: true,
    },
    appStoreLink: {
      type: String,
      required: true,
    },
    huaweiLink: {
      type: String,
      required: true,
    },
  },
  methods: {
    onGooglePlayClick() {
      this.pushDataLayer('all_client_click_download_app_play');
    },
    onAppStoreClick() {
      this.pushDataLayer('all_client_click_download_app_store');
    },
    onHuaweiStoreClick() {
      this.pushDataLayer('all_client_click_download_app_huawei');
    },
    pushDataLayer(event) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event });
    },
  },
};
</script>
